import { FC } from 'react'
import { useListBrands } from 'src/api/graphql'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons'

import { CarouselContainer, NavButton, LogoCard, LogoImage } from './styles'

const BrandCarousel: FC = () => {
  const { data } = useListBrands()

  const brands = data?.listSpecificBrands || []

  return (
    <CarouselContainer>
      <NavButton className="swiper-button-prev">
        <ArrowLeftOutlined size={20} />
      </NavButton>

      <Swiper
        modules={[Navigation]}
        spaceBetween={20}
        slidesPerView={1}
        navigation={{
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }}
        breakpoints={{
          640: { slidesPerView: 2 },
          768: { slidesPerView: 3.5 },
          1024: { slidesPerView: 5 },
        }}
      >
        {brands.map((brand: any, index: number) => (
          <SwiperSlide key={index}>
            <a href={brand.urlStore || '#'} style={{ textDecoration: 'none' }}>
              <LogoCard>
                <LogoImage src={brand.logoUrl} alt={brand.name} />
              </LogoCard>
            </a>
          </SwiperSlide>
        ))}
      </Swiper>

      <NavButton className="swiper-button-next">
        <ArrowRightOutlined size={20} />
      </NavButton>
    </CarouselContainer>
  )
}

export default BrandCarousel
